var exports = {
  "k": "x112a1f60--e00940--container",
  "K": "x112a1f60--e00940--icon",
};

module.exports = exports;
